import { of } from 'rxjs';

import Global from '../../../store/global-selectors';

import * as Actions from './batches.purchase.actions';
import * as EntitiesActions from '../../../store/entities/entities.actions';

import { BATCH_ENTITY_GROUP_NAME, BATCH_ENTITY_ID_ATTRIBUTE } from './constants';
import { normalizeDataArray, buildEntityPayload } from './data-helpers';

export const batchesErrorsAndWarningsResolution = (fulfillmentPlanSetId, excluded, getState) => {
  const state = getState();
  const batchEntity = Global.selectEntitiesBatchByFulfillmentPlanSetId(state, {
    fulfillmentPlanSetId,
  });
  const updatedBatch = {
    ...batchEntity,
    excluded,
  };
  const normalizedBatch = normalizeDataArray(BATCH_ENTITY_GROUP_NAME, BATCH_ENTITY_ID_ATTRIBUTE, [updatedBatch]);
  const entities = buildEntityPayload(normalizedBatch);

  return of(EntitiesActions.entitiesLoad(entities), Actions.costReviewBatches(fulfillmentPlanSetId, excluded));
};
